var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemTable',{attrs:{"title":"高齢受給者証","authDiv":_vm.authDiv,"headers":_vm.careRateCertHeaders,"items":_vm.items,"item_class":_vm.eldCertItemsRowBackground},on:{"makenew":_vm.eldCertCreate,"repair":_vm.eldCertRepair,"copy":_vm.eldCertCopy}})}
var staticRenderFns = []

export { render, staticRenderFns }